import { createFileRoute, Outlet, redirect } from "@tanstack/react-router"

import { AdminShell } from "@/components/layout/admin-shell"

export const Route = createFileRoute("/_authenticated/admin")({
  /**
   * Merrin staff only, and deliberately outside tenancy: a super admin does not
   * belong to the organisations they administer, so nothing here may require an
   * organisation to be set.
   */
  beforeLoad: ({ context }) => {
    if (!context.session.user.admin) {
      throw redirect({ to: "/" })
    }
  },
  component: AdminLayout,
})

function AdminLayout() {
  return (
    <AdminShell>
      <Outlet />
    </AdminShell>
  )
}
